import {observable, action, runInAction} from 'mobx'
import {get, json} from '../../../utils/ajax'
import {handleSeerchAndPage} from "../../../utils/Utils";

class HotPointStore {
    @observable loading
    @observable page
    @observable pagination
    @observable nineList//九大类
    @observable mainList//主组
    @observable mainPictureList//主组的图
    @observable groupList//分组
    @observable photoList//图片list
    @observable hotList//右侧热点
    @observable initCondition//初始化epc中间表热点条件
    @observable coordianteList//坐标列表
    @observable searchFields//条件查询图片
    @observable carsysId//整个页面车系id
    @observable picture//图片路径
    @observable carseriesName//车系名称
    @observable level1Selected//选中的菜单

    constructor() {
        this.picture = ''
        this.carsysId = ''
        this.loading = false
        this.page = {
            current: 0,
            total: 1
        }
        this.pagination = {
            current: 0,
            total: 1
        }
        this.carseriesName = ''
        this.hotList = []
        this.nineList = []
        this.mainList = []
        this.mainPictureList = []
        this.groupList = []
        this.photoList = []
        this.searchFields = {
            figureNo: '',
        }
        this.coordianteList = []
        this.initCondition = {
            carseriesId: '',
            catalogId: ''
        }
        this.level1Selected = ''
    }

    @action setDistance = (x, y) => {
        let temp = {
            x: x,
            y: y
        }
        runInAction(() => {
            this.coordianteList.push(temp)
        })

    }
    @action empetyMain = () => {
        runInAction(() => {
                this.mainList = []
            }
        )
    }
    @action empetyGroup = () => {
        runInAction(() => {
                this.groupList = []
            }
        )
    }
    @action empetyHot = () => {
        runInAction(() => {
                this.hotList = []
            }
        )
    }
    @action empetyPhoto = () => {
        runInAction(() => {
                this.photoList = []
            }
        )
    }
    @action getCarseriesId = (id) => {
        runInAction(() => {
                this.carsysId = id
            }
        )
    }

    //****************页面初始化加载***********************************************
    /**
     * 初始化页面，查出9大类和主组//（主组图）
     * @returns {Promise<void>}
     */
    @action
    initPage = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogs/carseriesId/${this.carsysId}/pId/${0}`)

        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        const cId = res[0].id
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogs/carseriesId/${this.carsysId}/pId/${cId}`)
        if (res1 && res1.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }

        const res2 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogphoto/carseriesId/${this.carsysId}/catalogId/${cId}`)
        if (res2 && res2.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }

        const res3 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/carseriesCatalog/${this.carsysId}`)
        if (res3 && res3.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.nineList = res
            this.mainList = res1
            this.mainPictureList = res2
            this.carseriesName = res3.carseriesName
            this.level1Selected = res[0].id
            this.loading = false
        })
    }

    //****************九大类主组分组********************************************
    /**
     * 点击9大类查主组
     * @param id
     * @returns {Promise<void>}
     */
    @action
    getMain = async (key) => {
        runInAction(() => {
            this.loading = true
            this.level1Selected = key
            this.picture = ''
            this.groupList = []
            this.hotList = []
            this.photoList = []
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogs/carseriesId/${this.carsysId}/pId/${key}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }

        const res2 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogphoto/carseriesId/${this.carsysId}/catalogId/${key}`)
        if (res2 && res2.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.mainList = res
            this.mainPictureList = res2
        })
    }
    /**
     * 点击主组查分组
     * @param id
     * @returns {Promise<void>}
     */
    @action
    getGroup = async (pid) => {
        runInAction(() => {
            this.loading = true
            this.picture = ''
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogs/carseriesId/${this.carsysId}/pId/${pid}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }

        runInAction(() => {
            this.loading = false
            this.groupList = res
        })
    }

    /**
     * 点击分组查右侧备件热点列表
     * @param id
     * @returns {Promise<void>}
     */
    @action
    getEpc = async (pid, page) => {
        runInAction(() => {
            this.loading = true
        })
        this.initCondition.catalogId = pid
        this.initCondition.carseriesId = this.carsysId
        let search = handleSeerchAndPage(page, this.pagination, this.initCondition)
        search.size = 80
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc_sparepart/gethotpoint:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.hotList = res.content || []
        })
    }
    /**
     * 显示图片
     * @returns {Promise<void>}
     */
    @action
    showPicture = async (catalogId, code) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogPhoto/carseriesId/${this.carsysId}/catalogId/${catalogId}/figureNo/${code}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }

        runInAction(() => {
            this.coordianteList = []
            this.picture = res.picture
             this.loading = false
        })

    }
    @action
    showExistPicture = (value) => {
        runInAction(() => {
            this.picture = value
        })
    }


    //****************右侧热点维护*******************************************
    /**
     * 新增热点
     * @returns {Promise<void>}
     */
    @action
    addhotpoint = async (id, catalogId) => {
        runInAction(() => {
            this.loading = true
        })
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc_sparepart/addhotpoint/id/${id}`, this.coordianteList)
        runInAction(() => {
            this.loading = false
            this.getEpc(catalogId)
        })
    }

    /**
     * 回显单条记录的热点到图上
     * @param coordinate
     * @returns {Promise<void>}
     */
    @action
    showhotpoint = async (coordinates) => {
        runInAction(() => {
            this.coordianteList = coordinates
        })
    }

    /**
     * 清空热点单个
     * @param id
     * @returns {Promise<void>}
     */
    @action
    delhotpoint = async (id, catalogId) => {
        runInAction(() => {
            this.loading = true
        })
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc_sparepart/delcoordinates/${id}`)
        runInAction(() => {
            this.loading = false
            this.getEpc(catalogId)
        })
        this.clearClick()
    }

    /**
     * 转存车系id和目录id
     */
    @action
    getCarseriesIdAndCatalogId = (carsid, catalogid) => {
        runInAction(() => {
            this.initCondition.carseriesId = carsid
            this.initCondition.catalogId = catalogid
        })
    }

    /**
     * 清空所有热点
     */
    @action
    delAllhotpoint = async () => {
        runInAction(() => {
            this.loading = true
        })
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc_sparepart/delallcoordinates/carseriesId/${this.initCondition.carseriesId}/catalogId/${this.initCondition.catalogId}`)
        runInAction(() => {
            this.loading = false
            this.coordianteList = []
            this.getEpc(this.initCondition.catalogId)
        })

    }

    //********************底部图片列表**********************************************
    /**
     * 表单查询条件改变
     * @param changedFields
     */
    @action
    searchFieldChange = (record) => {
        runInAction(() => {
            this.searchFields = {
                figureNo: record.figureNo,
            }
        })
    }
    /**
     *查询图片list
     */
    @action
    getPhoto = async (page) => {
        runInAction(() => {
            this.loading = true
            this.searchFields.carseriesId = this.carsysId
        })
        let search = handleSeerchAndPage(page, this.pagination, this.searchFields)
        search.size = 80
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/catalogPhoto/list`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.photoList = res.content || []
        })
    }
    @action
    getoneGroup = async (values) => {
        runInAction(() => {
            this.loading = true
            this.searchFields.carseriesId = this.carsysId
        })
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/epc/epc/getcatalogbycidandcode/carseriesId/${this.searchFields.carseriesId}/code/${values.figureNo}`)
        if (res1 && res1.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.groupList = res1
        })
    }
    @action
    gobackClick=()=>{
        this.coordianteList.pop()
    }
    @action
    clearClick=()=>{
        this.coordianteList = []
    }
}

export default new HotPointStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/HotPoint/store.js